import { create } from "zustand";
import toast from "react-hot-toast";
import { productsApi } from "../lib/api/products";

export const useProductStore = create((set, get) => ({
	products: [],
	featuredProducts: [],
	loading: false,
	error: null,
	setProducts: (products) => set({ products }),

	createProduct: async (productData) => {
		set({ loading: true });
		try {
			const newProduct = await productsApi.create(productData);
			set((prevState) => ({
				products: [...prevState.products, newProduct],
				loading: false,
			}));
		} catch (error) {
			toast.error(error.response?.data?.error || "שגיאה ביצירת מוצר");
			set({ loading: false });
		}
	},

	fetchAllProducts: async () => {
		set({ loading: true });
		try {
			const response = await productsApi.getAll();
			console.log('📦 נתוני מוצרים מהשרת:', response);
			
			// התמודדות עם פורמט התגובה
			let products = [];
			if (response.success && response.products) {
				products = response.products;
			} else if (Array.isArray(response)) {
				products = response;
			} else {
				console.error('פורמט תגובה לא מוכר:', response);
				products = [];
			}
			
			set({ products, loading: false });
		} catch (error) {
			console.error('שגיאה בטעינת מוצרים:', error);
			toast.error("שגיאה בטעינת מוצרים");
			set({ loading: false });
		}
	},

	fetchProductsByCategory: async (category) => {
		set({ loading: true });
		try {
			const response = await productsApi.getByCategory(category);
			console.log(`📦 נתוני מוצרים בקטגוריה ${category}:`, response);
			
			// התמודדות עם פורמט התגובה
			let products = [];
			if (response.success && response.products) {
				products = response.products;
			} else if (Array.isArray(response)) {
				products = response;
			} else {
				console.error(`פורמט תגובה לא מוכר לקטגוריה ${category}:`, response);
				products = [];
			}
			
			
			set({ products, loading: false });
		} catch (error) {
			console.error(`שגיאה בטעינת מוצרים בקטגוריה ${category}:`, error);
			toast.error("שגיאה בטעינת מוצרים");
			set({ loading: false });
		}
	},
	deleteProduct: async (productId) => {
		set({ loading: true });
		try {
			await productsApi.delete(productId);
			set((prevProducts) => ({
				products: prevProducts.products.filter((product) => product._id !== productId),
				loading: false,
			}));
		} catch (error) {
			set({ loading: false });
			const message = error?.response?.data?.error || error?.message || "Failed to delete product";
			toast.error(message);
		}
	},
	toggleFeaturedProduct: async (productId) => {
		set({ loading: true });
		try {
			const updatedProduct = await productsApi.toggleFeatured(productId);
			// this will update the isFeatured prop of the product
			set((prevProducts) => ({
				products: prevProducts.products.map((product) =>
					product._id === productId ? { ...product, isFeatured: updatedProduct.isFeatured } : product
				),
				loading: false,
			}));
		} catch (error) {
			set({ loading: false });
			const message = error?.response?.data?.error || error?.message || "Failed to update product";
			toast.error(message);
		}
	},
	fetchFeaturedProducts: async () => {
		set({ loading: true, error: null });
		try {
			const response = await productsApi.getFeatured();
			console.log('📦 נתוני מוצרים מומלצים מהשרת:', response);
			
			// התמודדות עם פורמט התגובה
			let products = [];
			if (response.success && response.products) {
				products = response.products;
			} else if (Array.isArray(response)) {
				products = response;
			} else {
				console.error('פורמט תגובה לא מוכר למוצרים מומלצים:', response);
				products = [];
			}
			
			set({ featuredProducts: products, loading: false });
		} catch (error) {
			console.error("Error fetching featured products:", error);
			set({ featuredProducts: [], error: "Failed to fetch products", loading: false });
		}
	},
	updateProduct: async (productId, updatedData) => {
		set({ loading: true });
		try {
			const updatedProduct = await productsApi.update(productId, updatedData);
			set((prevState) => ({
				products: prevState.products.map((product) =>
					product._id === productId ? updatedProduct : product
				),
				loading: false,
			}));
			toast.success('המוצר עודכן בהצלחה');
		} catch (error) {
			set({ loading: false });
			const message = error?.response?.data?.error || error?.message || 'שגיאה בעדכון מוצר';
			toast.error(message);
		}
	},
}));
